<template>
    <div :class='{"full-width": fullWidth}' class="has-feedback has-feedback-left" style="position: relative;">
        <div class="form-control-feedback over-almost-all">
            <i class="text-size-large-search cursor-pointer" :class="{'icon-search4': !doing, 'icon-spinner2 spinner': doing}"></i>
        </div>
        <input ref="searchElement" type="text" :value="query" class="form-control input-xlg full-width has-icon-left" :class="{'full-width': fullWidth}" @keyup.enter="doSearch" @keyup.escape="doClear" />
    </div>
</template>

<script>
export default {
  name: 'SearchBar',
  props: ['query', 'fullWidth', 'process'],

  data () {
    return {
      q: '',
      doing: false
    }
  },

  methods: {
    doSearch () {
      this.doing = true
      this.$emit('search', this.$refs.searchElement.value)
      this.doing = false
    },

    doClear () {
      this.doing = true
      this.$emit('clear')
      this.doing = false
    }
  },

  watch: {
    'process': function (to, from) {
      this.doing = to
    }
  }
}
</script>

<style scoped>

</style>
